import { CheckCircleRounded, Psychology, WatchLater, LocationOn } from "@mui/icons-material";
import { Chip, Divider, Grid, Paper, Typography } from "@mui/material";
import { Stack } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import JobDetailsModal from "../../JobList Components/JobDetailsModal";
import { tokens } from "../../../store/tokens";
import "./Job.css";

const Job = (props) => {
  const navigate = useNavigate();
  const { jobData } = props;
  const {
    job_budget,
    job_title,
    job_currency,
    job_expertlevel,
    job_id,
    job_info,
    poster_locat,
    job_poster,
    job_poster_name,
    job_refer,
    job_skill,
    job_time,
    poster_status,
  } = jobData;

  // job_skill sometimes arrives as a JSON array string — guard against a
  // malformed/empty value instead of letting JSON.parse throw and take
  // the whole card down with it.
  let skills = [];
  try {
    skills = job_skill ? JSON.parse(job_skill) : [];
  } catch {
    skills = [];
  }

  const [jobId, setJobId] = useState("");
  const [jobRefer, setJobRefer] = useState("");
  const [poid, setPoid] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const handleModalOpen = (refer, id, poid) => {
    setJobId(id);
    setJobRefer(refer);
    setPoid(poid);
    setModalOpen(!modalOpen);
  };

  return (
    <Paper
      elevation={0}
      onClick={() => handleModalOpen(job_refer, job_id, job_poster)}
      sx={{
        padding: `${tokens.card.padding.md}px`,
        cursor: "pointer",
        borderRadius: `${tokens.card.radius}px`,
        border: `1px solid ${tokens.color.line}`,
        transition: "box-shadow 0.15s ease, border-color 0.15s ease",
        "&:hover": {
          boxShadow: tokens.shadow.md,
          borderColor: tokens.color.teal,
        },
      }}
    >
      <Stack spacing={1.25}>
        <Stack direction={"row"} justifyContent={"space-between"} alignItems={"flex-start"} spacing={2}>
          <Typography variant="subtitle1" sx={{ color: tokens.color.ink }}>
            {job_title}
          </Typography>
          <Typography variant="subtitle1" sx={{ color: tokens.color.teal, whiteSpace: "nowrap" }}>
            {job_currency} {job_budget}
          </Typography>
        </Stack>

        <Stack direction={"row"} spacing={2} alignItems={"center"}>
          <Stack direction={"row"} spacing={0.5} alignItems={"center"}>
            <Psychology sx={{ fontSize: "1.1rem", color: tokens.color.inkFaint }} />
            <Typography variant="body2" sx={{ color: tokens.color.inkMuted }}>
              {job_expertlevel}
            </Typography>
          </Stack>
          <Stack direction={"row"} spacing={0.5} alignItems={"center"}>
            <WatchLater sx={{ fontSize: "1.1rem", color: tokens.color.inkFaint }} />
            <Typography variant="body2" sx={{ color: tokens.color.inkMuted }}>
              {job_time}
            </Typography>
          </Stack>
        </Stack>

        {job_info && (
          <Typography variant="body2" sx={{ color: tokens.color.inkMuted }}>
            {job_info.slice(0, 300)}…
          </Typography>
        )}

        {skills.length > 0 && (
          <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", gap: 1 }}>
            {skills.map((element) => (
              <Chip
                key={element}
                label={element}
                size="small"
                onClick={(e) => {
                  // Without this, clicking a chip also bubbled up to the
                  // card's onClick and opened the job modal at the same
                  // time as navigating away — two conflicting actions
                  // from one click.
                  e.stopPropagation();
                  navigate(`/joblist?skill=${encodeURIComponent(element)}`);
                }}
                sx={{
                  fontSize: "0.7rem",
                  fontWeight: 600,
                  color: tokens.color.white,
                  bgcolor: tokens.color.tealDark,
                  "&:hover": { bgcolor: tokens.color.teal },
                }}
              />
            ))}
          </Stack>
        )}

        <Divider sx={{ borderColor: tokens.color.line }} />

        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          <CheckCircleRounded
            sx={{
              fontSize: "1rem",
              color: poster_status == "1" ? tokens.color.success : tokens.color.inkFaint,
            }}
          />
          <Typography variant="body2" sx={{ color: tokens.color.inkMuted }}>
            {job_poster_name}
          </Typography>
          {poster_locat && (
            <>
              <Divider orientation="vertical" flexItem sx={{ borderColor: tokens.color.line }} />
              <Stack direction={"row"} spacing={0.5} alignItems={"center"}>
                <LocationOn sx={{ fontSize: "1rem", color: tokens.color.inkFaint }} />
                <Typography variant="body2" sx={{ color: tokens.color.inkMuted }}>
                  {poster_locat}
                </Typography>
              </Stack>
            </>
          )}
        </Stack>
      </Stack>

      <JobDetailsModal
        jobId={jobId}
        jobRefer={jobRefer}
        poid={poid}
        modalOpen={modalOpen}
        handleModalOpen={handleModalOpen}
      />
    </Paper>
  );
};

export default Job;
